var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full flex flex-col"},[(_vm.isShow)?_c('person-enter-content',{attrs:{"FormData":_vm.FormData,"formList":_vm.formList,"pageType":_vm.pageType},on:{"back":_vm.handleBack,"save":_vm.handleBack}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }